import { Link } from "react-router-dom";

import { useBreakpoint } from "@/hooks/useBreakpoint";
import { cn } from "@/lib/cn";

import { Appear } from "@/components/landing/Appear";
import { LandingButton } from "@/components/landing/LandingButton";
import { LandingVideo } from "@/components/landing/LandingVideo";
import { RevealGroup, RevealText } from "@/components/landing/RevealText";

const heroVideo = "/videos/landing/hero.mp4";
const balanceCard = "/images/landing/balance-card.png";

export const HeroSection = () => {
  const isDesktop = useBreakpoint("md");

  return (
    <section className="border-landing-line border-b">
      <RevealGroup className="landing-container flex flex-col items-center pt-[12.25rem] pb-[7.5rem] max-md:pt-[9rem] max-md:pb-16">
        <RevealText
          as="h1"
          className={cn(
            "text-landing-ink max-w-[56rem] text-center text-[3.5rem] leading-[1.08] font-semibold tracking-[-0.03em] max-md:text-[2rem]"
          )}
        >
          Не нужно жить в графике, чтобы пользоваться рынком
        </RevealText>

        <RevealText
          as="p"
          delay={70}
          className="text-landing-muted mt-6 max-w-[46rem] text-center text-[0.875rem] leading-[1.5] font-medium max-md:mt-4"
        >
          Автоматическая торговая система для людей, которые не хотят жить у графиков. Деньги
          остаются на вашей бирже, Spider управляет сделками в пределах выбранного риска и получает
          комиссию только с новой прибыли.
        </RevealText>

        <Appear
          delay={isDesktop ? 120 : 220}
          className="mt-12 flex items-center gap-2 max-md:mt-8 max-md:w-full"
        >
          <LandingButton
            variant="dark"
            asChild
            className="max-md:w-auto max-md:flex-1 max-md:px-4"
          >
            <Link to="/register">Запустить Spider</Link>
          </LandingButton>
          <LandingButton
            variant="light"
            asChild
            className="max-md:w-auto max-md:flex-1 max-md:px-4"
          >
            {/* Ниже 360px не помещается */}
            <Link to="/register">
              <span className="max-[22.5rem]:hidden">Попробовать демо</span>
              <span className="hidden max-[22.5rem]:inline">Демо</span>
            </Link>
          </LandingButton>
        </Appear>

        <Appear
          delay={isDesktop ? 220 : 0}
          // На мобильном наверх, текст под неё
          className="relative mt-20 aspect-[1040/640] w-full overflow-hidden rounded-3xl bg-neutral-900 max-md:order-first max-md:mt-0 max-md:mb-10 max-md:aspect-[5/4] max-md:rounded-2xl"
        >
          <LandingVideo
            className="absolute inset-0 h-full w-full object-cover"
            src={heroVideo}
          />
          <img
            src={balanceCard}
            alt="Баланс бота: $2506, +58% за 24 часа"
            className="pointer-events-none absolute top-1/2 left-1/2 w-[52.9%] max-w-[34.375rem] -translate-x-1/2 -translate-y-1/2 select-none max-md:w-[72%]"
          />
        </Appear>
      </RevealGroup>
    </section>
  );
};
